import { gql } from 'graphql-request'

export const GENERATE_DOWNLOAD_LINK = gql`
  mutation GenerateDownloadLinkMutation($id: ID!) {
    gerarLinkDownloadByItemBiblioteca(idItemBiblioteca: $id)
  }
`
